import Utility from "../../../helpers/paymentHelpers/utility";
import get from 'lodash/get';
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
import constant from "../../../helpers/paymentHelpers/constant";
import apiCalls from "../../../config/paymentConfig/apiCalls";
import headers from "../../../config/paymentConfig/headers";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";

export default {
	namespaced: true,
	state: {
		isAddressLoaded: false,
		isAddressSelected: true,
		addressObj: {},
		addressTxt: '',
		deliveryType: constant.ORDER_TYPE.DELIVERY,
		isAdvanceOrder: false,
		advanceOrderDateTime: {},
		responseAdvanceOrderData: []
	},
	getters: {},
	mutations: {
		updateAddressLoader(state, payload) {
			state.isAddressLoaded = payload;
		},
		updateAddressSelected(state, payload) {
			state.isAddressSelected = payload;
		},
		updateAddressObject(state, payload) {
			state.addressObj = payload;
		},
		updateAddressTxt(state, payload) {
			state.addressTxt = payload;
		},
		updateDeliveryType(state, payload) {
			state.deliveryType = payload;
		},
		updateIsAdvanceOrder(state, payload) {
			state.isAdvanceOrder = payload;
		},
		updateAdvanceOrderDateTime(state, payload) {
			state.advanceOrderDateTime = payload;
		},
	},
	actions: {
		getSelectedAddress({ commit, state }, payload) {
			try{
				const lastLocationNew = LocalStorageFunc.getLastLocationNew();
				//lastLocationNew is must for the address bar - for both logged-in and non logged-in users
				if(lastLocationNew.length > 0) {
					const advanceTime = LocalStorageFunc.getAdvanceOrderTimestamp();
					if(advanceTime) {
						if (advanceTime > 0) {
							const day = Utility.getAdvanceDateMonth(advanceTime * 1000);
							const time = Utility.formatAMPM(advanceTime * 1000);
							commit("updateAdvanceOrderDateTime", { day, time });
							commit("updateIsAdvanceOrder", true);
							
						}
					}
					// const advanceStore = getStorageValue(COOKIE_STORAGE_KEYS.ADVANCE_STORE);
					let recentLocation = get(lastLocationNew, '[0].recent', {});
					let recentStoreCoord = get(lastLocationNew, '[0].location', {});
					let deliveryType = get(lastLocationNew, '[0].deliveryType', constant.ORDER_TYPE.DELIVERY);
					commit("updateDeliveryType", deliveryType);
					if(deliveryType === constant.ORDER_TYPE.PICKUP || deliveryType === constant.ORDER_TYPE.DINEIN) {
						//Case - order type is pickup or dinein
						if(recentLocation.name) {
							commit("updateAddressObject", recentLocation);
						} else if(Utility.getSessionStorageValue("takeawayLocation") && Utility.getSessionStorageValue("takeawayLocation").name){
							let takeawayLocation = Utility.getSessionStorageValue("takeawayLocation");
							commit("updateAddressObject", takeawayLocation);
						} else {
							//redirect to cart
							console.log('No take away or dineIn address case');
							// ampUtility.dynamicAmplitudeEvent('redirect_payment', {
							// 	error: 'No take away or dineIn address case - Redirect to Cart Page',
							// 	deliveryType: JSON.stringify(deliveryType),
							// 	recentLocation: JSON.stringify(recentLocation),
							// 	takeawayLocation: JSON.stringify(Utility.getSessionStorageValue("takeawayLocation")),
							// 	Page_Name: "payment_lp", 
							// 	previousScreenname: "cart" 
							// });
							// Utility.sendToCartScreen()
						}
					} else if(deliveryType === constant.ORDER_TYPE.DELIVERY) {
						//Case - order type is delivery
						let address = {
							subLocality:
								get(recentLocation, 'sub_locality', '') ||
								get(recentLocation, 'area_level0', '') ||
								get(recentStoreCoord, 'sub_locality', ''),
							locality:
								get(recentLocation, 'addressComponent.locality', '') ||
								get(recentLocation, 'city_region', '') ||
								get(recentStoreCoord, 'locality', ''),
							city:
								get(recentLocation, 'addressComponent.city', '') ||
								get(recentLocation, 'city', '') ||
								get(recentStoreCoord, 'city', '')
						};
						const addressTxt = `${
							address.subLocality.trim() ? `${address.subLocality},` : ''
						} ${address.locality.trim() ? ` ${address.locality},` : ''} ${
							address.city.trim() ? ` ${address.city}` : ''
						}`;
						commit("updateAddressTxt", addressTxt);
						let addressView = {};
						const allUserAddresses = LocalStorageFunc.getUserAddresses();
						if(LocalStorageFunc.isLoggedIn() && allUserAddresses.length > 0) {
							//loggedIn case
							let matchAddress = Utility.isAddressAvailable(allUserAddresses, recentLocation, recentStoreCoord);
							if(!matchAddress) {
								//redirect to address
								console.log("No Location - redirect to address");
								// ampUtility.dynamicAmplitudeEvent('redirect_payment', {
								// 	error: 'No Matched Location - redirect to address',
								// 	deliveryType: JSON.stringify(deliveryType),
								// 	Page_Name: "payment_lp",
								// 	previousScreenname: "cart" 
								// });
								// window.location = "/address";
							} else {
								addressView = {
									houseNo: matchAddress.building_number,
									address: matchAddress.street_name,
									customer_address_name: matchAddress.addressType || matchAddress.customer_address_name || ''
								};
								if (matchAddress) {
									address = {
										subLocality: matchAddress.area_level0 || '',
										locality: matchAddress.city_region || '',
										city: matchAddress.city || ''
									};
								}
								commit("updateAddressObject", addressView);
							}
						} else {
							//non loggedIn case
							const selectedAddress = LocalStorageFunc.getSelectedAddress();
							const addressDetail = LocalStorageFunc.getAddressDetail();
							if(selectedAddress && selectedAddress?.houseNo && selectedAddress?.address) {
								addressView = selectedAddress;
							} else if(addressDetail && addressDetail?.houseNo && addressDetail?.address) {
								addressView = {
									houseNo: addressDetail.houseNo,
									address: addressDetail.address,
									customer_address_name: addressDetail.addressType
								};
							} else {
								//redirect to address page
								console.log("Logged out user Location - redirect to address");
								// ampUtility.dynamicAmplitudeEvent('redirect_payment', {
								// 	error: 'Logged out user No Location - redirect to address',
								// 	deliveryType: JSON.stringify(deliveryType),
								// 	selectedAddress: JSON.stringify(selectedAddress),
								// 	addressDetail: JSON.stringify(addressDetail),
								// 	Page_Name: "payment_lp",
								// 	previousScreenname: "cart" 
								// });
								// window.location = "/address";
							}
							commit("updateAddressObject", addressView);
						}
					}
				} else {
					//redirect to cart
					console.log("No Location - redirect to cart");
					// ampUtility.dynamicAmplitudeEvent('redirect_payment', {
					// 	error: 'No lastLocationNew - redirect to cart',
					// 	lastLocationNew: JSON.stringify(lastLocationNew),
					// 	Page_Name: "payment_lp",
					// 	previousScreenname: "cart" 
					// });
					// Utility.sendToCartScreen()
				} 
			} catch (err) {
				console.log('ERROR in ADDRESS OBJECT', err);
			} finally {
				// console.log('finally in ADDRESS OBJECT');
				commit("updateAddressLoader", true);
			}
		},
		advanceOrderApi({ state }, payload){
			let dType = LocalStorageFunc.getDeliveryType()
			let custmPayld;
			if(dType == "D"){
				custmPayld = {
					latitude: state.addressObj.latitude,
					longitude: state.addressObj.longitude,
					addressRequired: true,
				};
			} else {
				custmPayld = payload
			}
			apiCalls.ADVANCE_ORDER_TIME_API({
				headers: headers(),
				payload: custmPayld
			}).then(res => {
				state.responseAdvanceOrderData = res?.data?.timeSlots?.data || []
			}).catch(err => {
				console.log("");
			})
		}
	},
};